<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Service Pricing</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col-md-6">
              <div class="form-radio">
                <input type="radio" id="customer" [(ngModel)]="pricingType" [ngModelOptions]="{standalone: true}"
                       required (click)="clear()"
                       value="CUSTOMER" name="type">
                <label for="customer">Customer Pricing</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-radio">
                <input type="radio" id="orgRepricing" [(ngModel)]="pricingType" [ngModelOptions]="{standalone: true}"
                       required (click)="clear()"
                       value="ORG REPRICING" name="type">
                <label for="orgRepricing">Default Pricing</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div [hidden]="pricingType != 'CUSTOMER'">
                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="form-group mb-md-0">
                      <label class="control-label">Customer</label>
                      <ng-select id="accountOwner" [(ngModel)]="accountOwner"
                                 [ngModelOptions]="{standalone: true}" required
                                 [items]="accountOwners"
                                 bindLabel="ownerName"
                                 bindValue="id"
                                 [searchFn]="customSearchAccountOwner"
                                 [searchWhileComposing]="true">
                        <ng-template ng-option-tmp let-item="item">
                          {{item?.ownerName}} <br/>
                          <small>{{item?.companyName}}</small>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="form-group mb-md-0">
                      <label class="control-label">Services</label>
                      <select class="form-control" id="service" [(ngModel)]="service"
                              [ngModelOptions]="{standalone: true}" (change)="getList()" required>
                        <option value="KITTING">Kitting</option>
                        <option value="CUSTOM_LABEL">Custom Label</option>
                        <option value="DISPOSAL">Disposal</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <div class="table-3">
                      <table class="table packing-table-2">
                        <thead class="thead-light">
                        <tr>
                          <th>Tier</th>
                          <th>Minimun Quantity</th>
                          <th>Recurring Charge</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items1" name="list_name" value="m1"/>
                              <label for="items1">1</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier1MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"      [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier1RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"    [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items2" name="list_name" value="m2"/>
                              <label for="items2">2</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier2MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier2RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items3" name="list_name" value="m3"/>
                              <label for="items3">3</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier3MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"    [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier3RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items4" name="list_name" value="m4"/>
                              <label for="items4">4</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier4MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"     [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier4RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items5" name="list_name" value="m5"/>
                              <label for="items5">5</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier5MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier5RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items6" name="list_name" value="m6"/>
                              <label for="items6">6</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier6MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier6RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items7" name="list_name" value="m7"/>
                              <label for="items7">7</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier7MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier7RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="items8" name="list_name" value="m8"/>
                              <label for="items8">8</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="servicesList.tier8MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="servicesList.tier8RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div [hidden]="pricingType != 'ORG REPRICING'">
                <div class="row mt-3">
                  <div class="col-md-3">
                    <div class="form-group mb-md-0">
                      <label class="control-label">Services</label>
                      <select class="form-control" id="serviceOrg" [(ngModel)]="service"
                              [ngModelOptions]="{standalone: true}" (change)="getOrgList()" required>
                        <option value="KITTING">Kitting</option>
                        <option value="CUSTOM_LABEL">Custom Label</option>
                        <option value="DISPOSAL">Disposal</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <div class="table-3">
                      <table class="table packing-table-2">
                        <thead class="thead-light">
                        <tr>
                          <th>Tier</th>
                          <th>Minimun Quantity</th>
                          <th>Recurring Charge</th>
                        </tr>
                        </thead>
                        <tbody [hidden]="service == ''">
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item1" name="list_name" value="m9"/>
                              <label for="item1">1</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier1MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier1RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item2" name="list_name" value="m10"/>
                              <label for="item2">2</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier2MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier2RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item3" name="list_name" value="m11"/>
                              <label for="item3">3</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier3MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"    [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier3RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item4" name="list_name" value="m12"/>
                              <label for="item4">4</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier4MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier4RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item5" name="list_name" value="m13"/>
                              <label for="item5">5</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier5MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier5RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item6" name="list_name" value="m14"/>
                              <label for="item6">6</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier6MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier6RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item7" name="list_name" value="m15"/>
                              <label for="item7">7</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier7MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier7RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        <tr>
                          <td>
                            <div class="form-checkbox">
                              <input type="checkbox" id="item8" name="list_name" value="m16"/>
                              <label for="item8">8</label>
                            </div>
                          </td>
                          <td><input type="text" appOnlyNumbers [(ngModel)]="services.tier8MinQuantity"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"   [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                          <td><input type="text" onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)' [(ngModel)]="services.tier8RecurringCharge"
                                     onkeypress='return event.charCode >= 48 && event.charCode <= 57' maxlength="10"  [ngModelOptions]="{standalone: true}"
                                     class="form-control width-120"></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/adminDashboard/" class="btn btn-cancel">Cancel</button>
      <button type="submit" [hidden]="pricingType === 'ORG REPRICING'" (click)="fulfillmentSave()"
              class="btn btn-orange ml-2">Save
      </button>
      <button type="submit" [hidden]="pricingType === 'CUSTOMER'" (click)="orgSave()" class="btn btn-orange ml-2">Save
      </button>
    </div>
  </div>
</div>
